import React from "react";
import Image from "next/legacy/image";
import shaun from "public/marketing/sponsors/testimonial/shaun_vembutty.jpeg";
import ahstonGray from "public/marketing/sponsors/testimonial/ashtongray.png";
import doubleQuotes from "public/icons/double_quotes.svg";
import Link from "next/link";

const SponsorsTestimonial = () => {
  return (
    <div className="bg-white min-h-[540px] grid place-content-center py-20">
      <div className="w-full max-w-[896px] h-full flex flex-col md:flex-row items-center justify-between gap-x-8 gap-y-10 px-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl overflow-hidden w-[260px] h-[260px] relative z-[1]">
          <Image
            className="object-cover scale-110"
            src={shaun}
            width={260}
            height={260}
            alt="Shaun Vembutty"
            priority
            unoptimized
          />
        </div>
        <div className="flex flex-1 h-full flex-col justify-center gap-8 md:gap-[10px]">
          <div className="relative">
            <div className="w-[196px] h-[196px] absolute -left-6 -top-[100px] -z-0 select-none pointer-events-none">
              <Image src={doubleQuotes} width={196} height={196} alt="" />
            </div>
            <p className="text-gray-800 text-base font-normal text-center md:text-left relative z-[1]">
              <span className="text-xl font-semibold">
                "Since integrating Elmbase into our operations, it's been
                transformative.
              </span>{" "}
              The platform empowers our existing investors to become our
              greatest advocates, allowing us to tap into a wider network of
              potential investors. The data speaks for itself - our equity
              raises have never been this streamlined or successful. It truly
              feels as if Elmbase amplifies our reach without us lifting a
              finger. A game-changer for real estate sponsors."
            </p>
          </div>
          <div className="flex items-center justify-between gap-x-5">
            <div className="text-sm flex flex-col gap-y-1">
              <h6 className="text-gray-800 font-semibold">Shaun Vembutty</h6>
              <span className="text-gray-600">
                President @{" "}
                <Link
                  href="https://ashtongraydev.com/"
                  className="text-green-700 hover:underline">
                  
                    Ashton Gray Development
                  
                </Link>
              </span>
            </div>
            <div className="w-[100px] h-[51px]">
              <Image
                src={ahstonGray}
                width={100}
                height={51}
                alt="Ashton Gray Development"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SponsorsTestimonial;
